import React from 'react';
import { Text } from 'react-native';

import { WithColor } from '@styles/colors';
import type { FontStyles } from '@styles/fonts';

import type { LinkStatusInput } from '@components/search/operations/components/StartJobPopup/types';
import { resolveLinkStatusContent } from '@components/search/operations/components/StartJobPopup/components/LinkCurrentNcFile/helpers/resolveLinkStatusContent';

interface LinkStatusProps extends WithColor, LinkStatusInput {
  font: FontStyles;
}

// Renders the link-action status from the resolved descriptor — the status-to-content mapping lives in the helper.
const LinkStatus = ({ status, error, C, font }: LinkStatusProps) => {
  const content = resolveLinkStatusContent({ status, error });

  if (!content) return null;

  return <Text style={[font['Button 2'], { color: C(content.color) }]}>{content.label}</Text>;
};

export default LinkStatus;
